import { AnswerSurveyType } from 'models/Survey';
import {
  SubmittedFormListResponse,
  SubmittedFormPayload,
  SubmittedFormResponse,
} from 'types/services/SubmittedForm';
import axiosInstance from 'utils/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/submittedForm`;
class SubmittedForm {
  async getListByEnrollmentId(
    enrollmentId: string
  ): Promise<SubmittedFormListResponse> {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/getSubmittedFormByEnrollmentId/${enrollmentId}`
    );

    return data;
  }

  async saveSubmittedForm(payload: SubmittedFormPayload): Promise<SubmittedFormResponse> {
    const { data } = await axiosInstance.post(`${BASE_URL}/saveSubmittedForm`, payload);

    return data;
  }
}

export const SubmittedFormInstance = new SubmittedForm();
